export default {
      id: "protection-plans-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#protection-plans",
      toString: function () {
        return this.url;
      }
    }